import { render, staticRenderFns } from "./ModalAgenteSistema.vue?vue&type=template&id=28ecfb80&scoped=true&"
import script from "./ModalAgenteSistema.vue?vue&type=script&lang=js&"
export * from "./ModalAgenteSistema.vue?vue&type=script&lang=js&"
import style0 from "./ModalAgenteSistema.vue?vue&type=style&index=0&id=28ecfb80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ecfb80",
  null
  
)

export default component.exports